import { render, staticRenderFns } from "./SubjectReaction.vue?vue&type=template&id=1c714724&scoped=true&"
import script from "./SubjectReaction.vue?vue&type=script&lang=ts&"
export * from "./SubjectReaction.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectReaction.vue?vue&type=style&index=0&id=1c714724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c714724",
  null
  
)

export default component.exports